import React from 'react'
import CreateEditResourceForm from '../components/User/CreateEditResourceForm'
const CreateResource = () => {
    return (
        <CreateEditResourceForm  mode="add"/>
    )
}

export { CreateResource }